import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Music, ExternalLink, Lock } from "lucide-react";

const MOOD_COLOR = {
  angry: "text-red-300",
  sad: "text-blue-300",
  happy: "text-yellow-200",
  reminder: "text-purple-300",
  recovery: "text-teal-300",
  reflection: "text-neutral-200",
};

const FeaturedTrack = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/soundtrack/featured").then(({ data }) => setData(data)).catch(() => {});
  }, []);

  if (!data || !data.track) return null;
  const { track, owns_soundtrack, playlist_url } = data;

  return (
    <div className="card-surface p-6 md:p-7 relative overflow-hidden" data-testid="featured-track">
      <div className="absolute -right-10 -top-10 w-56 h-56 rounded-full bg-teal-500/10 blur-3xl pointer-events-none" />
      <div className="relative flex items-start gap-4">
        <div className="p-3 rounded-xl bg-teal-500/10 border border-teal-500/30 flex-shrink-0">
          <Music className="text-teal-300" size={20} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-xs uppercase tracking-widest text-teal-300/80 mb-1">This week's listen</div>
          <div className="mb-1">
            <span className="font-display text-2xl text-neutral-100" data-testid="featured-title">{track.title}</span>
            <span className="text-neutral-500 text-base"> — {track.artist}</span>
          </div>
          <div className={`text-xs uppercase tracking-widest mb-3 ${MOOD_COLOR[track.mood] || MOOD_COLOR.recovery}`}>
            {track.mood}
          </div>
          {owns_soundtrack ? (
            <>
              {track.note && (
                <p className="text-sm text-neutral-300 italic leading-relaxed mb-4">"{track.note}"</p>
              )}
              {playlist_url && (
                <a
                  href={playlist_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="featured-playlist-link"
                  className="text-sm text-teal-300 hover:text-teal-200 inline-flex items-center gap-1"
                >
                  Open playlist in YouTube Music <ExternalLink size={12} />
                </a>
              )}
            </>
          ) : (
            <Link
              to="/soundtrack/preview"
              data-testid="featured-unlock-link"
              className="text-sm text-teal-300 hover:text-teal-200 inline-flex items-center gap-1"
            >
              <Lock size={12} /> Unlock The Soundtrack to hear this week's story
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default FeaturedTrack;
